import { useState } from 'react';
import { Box, styled } from '@material-ui/core';
import {
  SButton,
  SelectDetailsButton,
  SSelectDropdown,
  SText
} from '@setvi/shared/components';
import CloseIcon from '@material-ui/icons/Close';
import { TextColor } from '@setvi/shared/enums';

const StyledButton = styled(SButton)(({ theme }) => ({
  minHeight: 'max-content',
  padding: theme.spacing(1, 2),
  fontSize: 12,
  fontWeight: 500
}));

interface ProductFilterProps {
  title: string;
  label?: string;
  highlighted?: boolean;
  dropdownContent: JSX.Element;
  anchorWidth?: number | string;
  width?: number;
  disabled?: boolean;
  fontColor?: TextColor;
  clearAll?: () => void;
}

export const ProductFilter = ({
  title,
  label,
  highlighted,
  anchorWidth = 145,
  width = 216,
  dropdownContent,
  fontColor = TextColor.Grey,
  disabled,
  clearAll
}: ProductFilterProps) => {
  const [anchor, setAnchor] = useState(null);

  return (
    <SSelectDropdown
      newDesign
      dropdownContainerStyle={{ borderRadius: 12 }}
      anchor={
        <SelectDetailsButton
          style={{
            padding: '4px 12px',
            minHeight: 32,
            backgroundColor: '#F8F9FA'
          }}
          fontColor={fontColor || TextColor.Grey}
          width={anchorWidth}
          noBorder
          title={title}
          titleHighligted={highlighted}
          onClick={e => !disabled && setAnchor(e?.currentTarget)}
          open={Boolean(anchor)}
        />
      }
      anchorElement={anchor}
      onClose={() => setAnchor(null)}
      content={
        <Box
          width={width}
          display="flex"
          flexDirection="column"
          maxHeight={265}
          overflow="hidden">
          <Box
            padding="12px 10px 0px"
            display="flex"
            justifyContent="space-between"
            alignItems="center">
            {label && (
              <Box height={32}>
                <SText
                  title={label}
                  size="sm"
                  lineHeight="20px"
                  weight="semibold"
                />
              </Box>
            )}
            {clearAll && (
              <StyledButton
                variant="text"
                startIcon={<CloseIcon />}
                onClick={clearAll}>
                Clear All
              </StyledButton>
            )}
          </Box>
          <Box overflow="auto" flex={1} onClick={() => setAnchor(null)}>
            {dropdownContent}
          </Box>
        </Box>
      }
    />
  );
};
